import childIcon from './../../assets/child-icon.png'
import netIcon from './../../assets/net-icon.png'


export const aboutUsData = {
    title: "About Open Curtains Casting",
    whoWeAre: {
      title: "Who We Are",
      description:
        `Welcome to Open Curtains Casting, LLC, the ultimate online casting platform connecting talented actors and film crew with Casting Directors and Producers. Our mission is to streamline the casting process, making it easier than ever for industry professionals to discover the right talent for their projects.
Whether you're an aspiring performer looking for your next big break or a production team in search of the perfect cast and crew, we provide a seamless, efficient, and user-friendly platform to bridge the gap between talent and opportunity.
At Open Curtains Casting, LLC, we believe in empowering creatives by offering them access to industry professionals and career-defining opportunities. Join us today and take your career—or your production—to the next level.`,
      
    },
    features: [
      {
        title: "Build a professional portfolio for your child",
        icon: netIcon,
      },
      {
        title: "Apply to a variety of casting calls all over the U.S.",
        icon: childIcon,
      },
      {
        title: "Network with fellow parents & casting directors",
        icon: netIcon,
      },
    ],
    whatWeDo: {
      title: "What We Do",
      for_Talent: {
        title: "For Talent (Actors, Models, and Crew)",
        points: [
          "Create a professional profile showcasing your skills, experience, and portfolio.",
        "Get discovered by top Casting Directors and Producers searching for fresh talent.",
        "Apply for casting calls and job opportunities that match your expertise."
        ]
      },
      for_directors: {
        title: "For Casting Directors & Producers",
        points: [
          "Instantly browse a diverse pool of actors, models, and crew members.",
          "Post casting calls and job listings to attract the right talent.",
          "Use advanced search and filtering tools to find candidates based on experience, skills, and location.",
          "Manage auditions and communicate with talent efficiently through our platform."
        ]
      },
      description:
        `Open Curtains Casting, LLC is an innovative online casting platform designed to connect actors, and film crew with Casting Directors and Producers. We simplify the casting process by providing a digital space where industry professionals can efficiently discover and hire the right talent for their projects.`
    },
    benefits: {
      title: "What Open Curtains Casting can give You",
      items: [
        {
          title: "Development benefits",
          description:
            "Creative activities play an extremely important role in child's development. Introducing your child to acting and modeling will not only become their favourite new hobby, but it can give them important and useful skills that they will have for the rest of their life. For example, elevate their confidence levels, be a great tool of self-expression and introduce them to many new friendships.",
        },
        {
          title: "Financial benefits",
          description:
            "Modeling and acting jobs can also be rewarding financially. Open Curtains Casting offers many paid opportunities  of all ages, from baby modeling to acting and performing. Whether you'd like some extra funds for your kid's toys or are looking for something that can help once they're in college, Modeling and Acting is beneficial in every way. Especially with college tuitions rising each year. So why not have your child practice something they truly enjoy and earn extra at the same time?",
        },
        
      ],
    },
    contactInfo: {
      phone: "1-800-981-1902",
      hours: "Monday-Friday 8am-5pm PST",
      email: "support@kidscasting.com",
    },
    otherInfo: [
      { title: "Subscription Cancellation", link: "#" },
      { title: "Refund Policy", link: "#" },
      { title: "Prices", link: "#" },
    ],
    legal: [
      { title: "Terms of Use", link: "#" },
      { title: "Privacy Policy", link: "#" },
      { title: "Labor Laws", link: "#" },
    ],
  };
  